import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const WelcomeMeet2025details = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Welcome MSB Meet-Up /n19th June 2025";

  const title = "Welcome MSB Meet-Up /n19th June 2025";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Welcome MSB Meet-Up 19th June 2025 | MSB</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Welcome MSB Meet-Up 19th June 2025 | MSB"
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/events">Events</NavLink>
              </li>
              <li className="active">
                <a href="#!">Welcome MSB Meet-Up 19th June 2025</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              {/* <h2 className="item_details_heading">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2> */}
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/events" className="btn bg-primary text-dark">
                  &larr; Back
                </NavLink>
              </div>
              <img
                className="rounded-2"
                src="assets/images/events/welcome-meet-june.png"
                alt="Welcome MSB Meet-Up 19th June 2025"
              />

              <h3 className="mt-4 mb-5 text-center">
                MSB ASSOCIATION MEET-UP London | What an EVENING!
              </h3>

              <h4>
                A Powerful Evening of Insight, Leadership & Real-World Exchange
              </h4>
              <p className="mb-2">
                On <strong>Thursday, 19th June 2025</strong>, we brought the MSB
                community together—live in London.
              </p>
              <p className="mb-2">
                Hosted at{" "}
                <strong>McDermott Will & Emery UK LLP, 22 Bishopsgate</strong>,
                the event welcomed over <strong>50+ professionals</strong> for
                an evening packed with powerful conversations.
              </p>
              <p className="mb-2">
                From actionable insights on compliance and banking challenges to
                forward-looking takes on fintech innovation and regulatory
                strategy, the conversations sparked ideas and momentum.
              </p>
              <p>
                This was more than a meetup—it was a moment. A pulse checks on
                where the industry is headed, what’s changing fast, and how MSBs
                can lead the future.
              </p>

              <div className="text-center">
                <h4>Our Speaker Line-Up: Industry Leaders, Unfiltered</h4>
                <p>
                  We were joined by five exceptional voices who are shaping the
                  future of finance and compliance:
                </p>
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-4">
                    <NavLink
                      to="https://uk.linkedin.com/in/vishal-patil-78181914"
                      target="_blank"
                    >
                      <div
                        className="blog_post_block"
                        style={{
                          padding: "20px",
                          border: "2px solid gold",
                          borderRadius: "20px",
                        }}
                      >
                        <div className="post_image">
                          <img
                            src="assets/images/our-team/MSB-Vishal-Sir-Photo.png"
                            alt="Mr. Vishal Patil"
                          />
                        </div>
                        <div className="post_content text-center pb-0 mb-0">
                          <h4 className="text-dark">Mr. Vishal Patil</h4>
                          {/* <ul className="post_meta unordered_list text-uppercase">
                        <li>
                          <a href="#!" className="text-dark">
                            <span className="meta_label mt-2">
                              <i class="fa-solid fa-briefcase"></i> &nbsp;
                              Chairman
                            </span>
                          </a>
                        </li>
                      </ul>                      */}
                        </div>
                      </div>
                    </NavLink>
                  </div>

                  <div className="col-lg-4">
                    <NavLink
                      to="https://www.linkedin.com/in/andrew-butel/"
                      target="_blank"
                    >
                      <div
                        className="blog_post_block"
                        style={{
                          padding: "20px",
                          border: "2px solid gold",
                          borderRadius: "20px",
                        }}
                      >
                        <div className="post_image">
                          <img
                            src="assets/images/our-team/Andrew.png"
                            alt="Mr. Andrew Butel"
                          />
                        </div>
                        <div className="post_content text-center pb-0 mb-0">
                          <h4 className="text-dark">Mr. Andrew Butel</h4>
                          {/* <ul className="post_meta unordered_list text-uppercase">
                        <li>
                          <a href="#!" className="text-dark">
                            <span className="meta_label mt-2">
                              <i class="fa-solid fa-briefcase"></i> &nbsp;
                              Chairman
                            </span>
                          </a>
                        </li>
                      </ul>*/}
                        </div>
                      </div>
                    </NavLink>
                  </div>
                  <div className="col-lg-4">
                    <NavLink
                      to="https://www.linkedin.com/in/mizan-abdulrouf-49a67818/"
                      target="_blank"
                    >
                      <div
                        className="blog_post_block"
                        style={{
                          padding: "20px",
                          border: "2px solid gold",
                          borderRadius: "20px",
                        }}
                      >
                        <div className="post_image">
                          <img
                            src="assets/images/our-team/Mizan.png"
                            alt="Mr. Mizan Rouf"
                          />
                        </div>
                        <div className="post_content text-center pb-0 mb-0">
                          <h4 className="text-dark">Mr. Mizan Rouf</h4>
                          {/* <ul className="post_meta unordered_list text-uppercase">
                        <li>
                          <a href="#!" className="text-dark">
                            <span className="meta_label mt-2">
                              <i class="fa-solid fa-briefcase"></i> &nbsp;
                              Chairman
                            </span>
                          </a>
                        </li>
                      </ul>                      */}
                        </div>
                      </div>
                    </NavLink>
                  </div>
                  <div className="col-lg-4 mt-3">
                    <NavLink
                      to="https://www.linkedin.com/in/raminta-dereskeviciute-608128/"
                      target="_blank"
                    >
                      <div
                        className="blog_post_block"
                        style={{
                          padding: "20px",
                          border: "2px solid gold",
                          borderRadius: "20px",
                        }}
                      >
                        <div className="post_image">
                          <img
                            src="assets/images/our-team/Raminta.png"
                            alt="Ms. Raminta Dereskeviciute"
                          />
                        </div>
                        <div className="post_content text-center pb-0 mb-0">
                          <h4 className="text-dark">
                            Ms. Raminta Dereskeviciute
                          </h4>
                          {/* <ul className="post_meta unordered_list text-uppercase">
                        <li>
                          <a href="#!" className="text-dark">
                            <span className="meta_label mt-2">
                              <i class="fa-solid fa-briefcase"></i> &nbsp;
                              Chairman
                            </span>
                          </a>
                        </li>
                      </ul>                      */}
                        </div>
                      </div>
                    </NavLink>
                  </div>
                  <div className="col-lg-4 mt-3">
                    <NavLink
                      to="https://www.linkedin.com/in/saima-hanif-kc-4947662/"
                      target="_blank"
                    >
                      <div
                        className="blog_post_block"
                        style={{
                          padding: "20px",
                          border: "2px solid gold",
                          borderRadius: "20px",
                        }}
                      >
                        <div className="post_image">
                          <img
                            src="assets/images/our-team/Saima.png"
                            alt="Ms. Saima Hanif KC"
                          />
                        </div>
                        <div className="post_content text-center pb-0 mb-0">
                          <h4 className="text-dark">Ms. Saima Hanif KC</h4>
                          {/* <ul className="post_meta unordered_list text-uppercase">
                        <li>
                          <a href="#!" className="text-dark">
                            <span className="meta_label mt-2">
                              <i class="fa-solid fa-briefcase"></i> &nbsp;
                              Chairman
                            </span>
                          </a>
                        </li>
                      </ul>                      */}
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>
                <p className="mt-4">
                  <strong>
                    From regulatory evolution to technology’s role in risk and
                    resilience, every speaker brought unique, actionable insight
                    to the table.
                  </strong>
                </p>
              </div>

              <div className="row mb-4 mt-5 align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                  <div className="schedule-date fw-bold fs-5">
                    Event Highlights
                  </div>
                  <div className="schedule-card">
                    <div className="schedule-item mb-2">
                      <ul>
                        <li>
                          50+ attendees from fintech, legal, MSBs, and
                          compliance backgrounds
                        </li>
                        <li>Live Q&A with no-script, real-talk moments</li>
                        <li>Cross-sector networking and thought leadership</li>
                        <li>
                          Hosted in the heart of London’s financial district
                        </li>
                        <li>
                          Powerful conversations that continued long after the
                          stage lights dimmed
                        </li>
                      </ul>
                    </div>
                    <p>
                      <strong>
                        <em>
                          “This wasn’t just another event—it was a conversation
                          the industry needed.” – Participant, MSB Founder
                        </em>
                      </strong>
                    </p>
                  </div>
                </div>

                <hr className="d-block d-sm-none" />

                <div className="col-lg-6 col-md-6 col-12">
                  <img
                    src="/assets/images/event-banner/MSB-Meet-UP.jpg"
                    alt="Event"
                    className="img-fluid rounded-2 d-none"
                  />
                  {/* ===== RESPONSIVE IFRAME START ===== */}
                  <div className="video-responsive-wrapper">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/xskm0gqOufI?si=QTpMEzYc3IUsJN6J"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                  {/* ===== RESPONSIVE IFRAME END ===== */}
                </div>
              </div>

                  <div
                className="p-5 mt-5 text-center"
                style={{ background: "#f7931e", borderRadius: "10px" }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <h2 className="heading_text mb-4 text-white">
                      The Momentum Doesn’t Stop Here
                    </h2>
                    <p className="mb-3 text-white">
                      <strong>
                        We’re just getting started. More events. More voices.
                        More MSBs moving forward-together.
                      </strong>
                    </p>
                    <h5 className="text-white">
                      Mark Your Calendar - Engage with the MSB Network
                    </h5>
                    <NavLink
                      className="btn-black bg-primary btn-rounded mt-4"
                      to="/overview#membership-form"
                    >
                      <span className="btn_label">Become a Member</span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default WelcomeMeet2025details;
